<template>
  <el-dialog
    class="psEventDialog mainFont"
    :title="title"
    :visible.sync="dialogVisible"
    :width="isMobile == true ? '100%' : '50%'"
    :destroy-on-close="true"
    :before-close="handleClose"
    :append-to-body="true"
    >

      <div class="column columnContent" style="align-items: flex-start">
        <div class="row rowDate">
          <div class="column">
            <div class="label">Fecha</div>
            <el-date-picker
              v-model="calendarDate"
              type="date"
              placeholder="Seleccione una fecha"
              format="dd/MM/yyyy"
              :picker-options="pickerOptionsFutureDate"
              :default-value="new Date()"
              :disabled="calendarId > 0"
              ></el-date-picker>
          </div>
          <div class="column">
            <div class="column">
              <div class="label">Tipo de evento</div>
              <el-select v-model="calendarTypeId" placeholder="Seleccionar" :disabled="calendarId > 0">
                <el-option v-for="(calendarType, index) in patientCalendarTypes" :key="index" :value="calendarType.calendarTypeId" :label="calendarType.calendarTypeDescription"></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="row" style="justify-content: flex-start; width: 100%;" v-if="patientDisplay">
          <span class="patientCount">Se creará un evento para <b>{{patientDisplay}}</b></span>
        </div>
        <div class="column w-100 columnSelectPatient" v-else>
          <div class="label">Seleccionar paciente</div>
          <el-autocomplete
            class="patient"
            v-model="autocompletePatient"
            :fetch-suggestions="patientsList"
            :debounce="800"
            placeholder="Comience a escribir el nombre del paciente"
            @select="selectPatient"></el-autocomplete>
        </div>

        <div class="column w-100 columnTextarea" style="margin-bottom: 20px">
          <div class="label">Observaciones</div>
          <textarea name="calendarDescription" class="textarea" cols="58" rows="5" v-model="calendarDescription" placeholder="Observaciones"></textarea>
        </div>

        <div class="column w-100 columnTextarea" style="margin-bottom: 20px">
          <div class="label">Acciones</div>
          <textarea name="action" class="textarea" cols="58" rows="5" v-model="action" :maxlength="500" placeholder="Acciones tomadas"></textarea>
        </div>

        <div class="column w-100" style="margin-bottom: 20px;" v-if="calendarId">
          <div class="label">Repetir evento en: </div>
          <el-row>
            <el-button round @click.native.prevent="repeatEvent(30)">30 días</el-button>
            <el-button round @click.native.prevent="repeatEvent(60)">60 días</el-button>
            <el-button round @click.native.prevent="repeatEvent(90)">90 días</el-button>
          </el-row>
        </div>

        <div class="row rowButton">
          <el-button type="primary" round @click="save" :disabled="!canSave">Guardar</el-button>
          <el-button type="danger" round plain @click="$emit('delete')" v-if="event && event.calendarId > 0">Eliminar</el-button>
        </div>
    </div>

  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { searchPatients } from './../../services/patients_service'

export default {
  name: 'PsEventDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Nuevo evento'
    },
    patient: {
      type: [Object, String],
      default: null
    },
    defaultEvent: {
      type: String,
      default: ''
    },
    event: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pickerOptionsFutureDate: {
        disabledDate(time) {
          const d = new Date()
          return time.getTime() < new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0,0,0);
        },
      },
      calendarId: null,
      calendarDate: null,
      calendarTypeId: null,
      calendarDescription: '',
      action: '',
      autocompletePatient: '',
      selectedPatientData: null,
      patientSearchController: null,
      patientSearchRequestId: 0
    }
  },
  computed: {
    ...mapState('calendarTypes', ['calendarTypes']),
    ...mapState(['isMobile']),
    dialogVisible: {
      get () { return this.visible },
      set (value) { this.$emit('update:visible', value) }
    },
    patientCalendarTypes () {
      return this.calendarTypes
    },
    patientDisplay () {
      if (!this.patient) return ''
      if (typeof this.patient == 'string') return this.patient
      if (this.patient.name || this.patient.surname) return `${this.patient.name || ''} ${this.patient.surname || ''}`.trim()
      return this.patient.value || ''
    },
    canSave () {
      const hasPatient = !!this.patient || !!this.selectedPatientData
      return !!this.calendarDate && this.calendarTypeId > 0 && hasPatient
    }
  },
  watch: {
    autocompletePatient (newValue) {
      this.cancelPatientSearch()
      if (this.selectedPatientData && newValue == this.selectedPatientData.value) return
      this.selectedPatientData = null
    },
    dialogVisible (value) {
      if (!value) {
        this.cancelPatientSearch()
        this.autocompletePatient = ''
        this.selectedPatientData = null
      } else {
        this.initForm()
      }
    }
  },
  methods: {
    ...mapActions('calendarTypes', ['getCalendarTypesHTTP']),
    handleClose () {
      this.dialogVisible = false
    },
    selectPatient (patient) {
      if (patient) this.selectedPatientData = patient
    },
    initForm () {
      if (this.event) {
        this.calendarId = this.event.calendarId
        this.calendarDate = this.event.calendarDate
        this.calendarTypeId = this.event.calendarType
        this.calendarDescription = this.event.calendarDescription || ''
        if (this.event.patientId > 0) {
          this.selectedPatientData = { patientId: this.event.patientId, value: this.event.patient }
          this.autocompletePatient = this.event.patient
        }
        this.action = this.event.action
      } else {
        this.calendarDate = null
        this.calendarTypeId = this.defaultEvent ? +this.defaultEvent : null
        this.calendarDescription = ''
      }
    },
    repeatEvent (days) {
      debugger
      
      const events = [{
        calendarId: this.event ? this.event.calendarId : 0,
        patient: typeof this.patient == 'object' && this.patient ? this.patient : this.selectedPatientData,
        calendarDate: this.calendarDate,
        calendarType: this.calendarTypeId,
        calendarDescription: this.calendarDescription,
        action: 'Se crea un evento para ' + days + ' días después. ' + (this.action || '')
      },{
        calendarId: 0,
        patient: typeof this.patient == 'object' && this.patient ? this.patient : this.selectedPatientData,
        calendarDate: new Date(new Date(this.calendarDate).setDate(new Date(this.calendarDate).getDate() + days)),
        calendarType: this.calendarTypeId,
        calendarTypeDescription: this.calendarTypeDescription,
        calendarDescription: this.calendarDescription,
        action: this.action
      }]
      this.$emit('save', events)
    },
    save () {
      // const calendarType = this.patientCalendarTypes.find(t => t.calendarTypeId == this.calendarTypeId)
      this.$emit('save', [{
        calendarId: this.event ? this.event.calendarId : 0,
        patient: typeof this.patient == 'object' && this.patient ? this.patient : this.selectedPatientData,
        calendarDate: this.calendarDate,
        calendarType: this.calendarTypeId,
        calendarDescription: this.calendarDescription,
        action: this.action
      }])
    },
    cancelPatientSearch () {
      this.patientSearchRequestId++
      if (this.patientSearchController) this.patientSearchController.abort()
      this.patientSearchController = null
    },
    async patientsList (query, cb) {
      const normalizedQuery = query.trim()
      this.cancelPatientSearch()
      if (normalizedQuery.length < 3) return cb([])

      const controller = new AbortController()
      const requestId = ++this.patientSearchRequestId
      this.patientSearchController = controller

      try {
        const patients = await searchPatients(normalizedQuery, { signal: controller.signal })
        if (requestId != this.patientSearchRequestId) return
        this.patientSearchController = null
        return cb(patients.map(patient => ({
          ...patient,
          value: patient.value || `${patient.name || ''} ${patient.surname || ''}`.trim()
        })))
      } catch (error) {
        if (requestId != this.patientSearchRequestId || controller.signal.aborted || error.code == 'ERR_CANCELED') return
        this.patientSearchController = null
        return cb([])
      }
    },
  },
  created () {
    if (!this.calendarTypes || this.calendarTypes.length == 0) {
      this.getCalendarTypesHTTP()
    }
    if (this.defaultEvent) {
      this.calendarTypeId = +this.defaultEvent
    }
  },
  beforeDestroy () {
    this.cancelPatientSearch()
  }
}
</script>

<style scoped>
  .rowDate { justify-content: space-between; width: 100%;}
  .columnContent { align-items: center; margin-right: 0;}
  .columnSelectPatient { width: 100%; max-width: 475px; align-items: flex-start; margin-bottom: 15px}
  .patient { margin-top: 15px; width: 100%}
  .columnTextarea { width: 100%; margin-right: 0;}
  .patientCount { color: #777; font-size: 1rem; margin-bottom: 10px;}
  .textarea { width: 100%; font-family: Helvetica, sans-serif; color: #606266; border-radius: 4px; padding: 5px; box-sizing: border-box; }
  .textarea:focus-visible { outline-color: #3e8091; outline-width: 0px; border-color: #3e8091}
  .rowButton { justify-content: center; }

  @media (max-width: 991.98px) {
    .rowDate { flex-direction: column; width: 100%}
    .column { margin-right: 0;}
    .rowDate > .column { margin-bottom: 15px;}
  }
</style>
